import dayjs from 'dayjs';

import {
  ticketLastUpdatedFilterMap,
  TicketLastUpdatedOptions,
} from './filter/ticketFilters.constants';

export type TicketDateRangeType = {
  after: Date | undefined;
  before: Date | undefined;
};
/**
 *
 * @param current current user selected last updated time range. such as: past10Days
 *
 * @returns before used for the api.
 */
export const getTicketDateRange = (
  current: TicketLastUpdatedOptions,
): TicketDateRangeType => {
  // for any time, set the before/after to undefined directly.
  if (current === TicketLastUpdatedOptions.Anytime) {
    return { after: undefined, before: undefined };
  }

  const afterFilterVal = ticketLastUpdatedFilterMap[current];
  const after = afterFilterVal
    ? dayjs()
        .minute(0)
        .second(0)
        .millisecond(0)
        .subtract(afterFilterVal[0], afterFilterVal[1])
        .toDate()
    : undefined;

  return { after, before: undefined };
};
